export default {
  AUTH_REQUEST(state) {
    state.status = 'loading'
  },

  AUTH_INVITE_LOADED(state) {
    state.status = 'success'
  },

  AUTH_SUCESS_REGISTER(state, user) {
    state.status = 'success'
    state.user = Object.assign(state.user, user)
    state.message = ''
  },

  AUTH_USER_LOGGED(state) {
    state.isLogged = true
  },

  AUTH_SUCESS_REGISTER_ACTIVE(state, token) {
    state.status = 'success'
    state.accountId = token
  },

  AUTH_SUCESS(state, obj) {
    state.status = 'success'
    state.user = obj.user
    state.message = ''
  },

  AUTH_ERROR(state, message) {
    state.status = 'error'
    state.accountId = ''
    state.message = message
  },

  AUTH_NEW_PASSWORD(state) {
    state.status = 'success'
  },

  CHANGE_IMAGE(state) {
    state.userAvatar = state.userAvatar + '1'
    state.avatarVersion++
  },

  LOAD_USER_DATA(state, userData) {
    state.organizationId = userData.organizationId
    state.user = userData.user
  },

  LOGOUT(state) {
    state.status = ''
    state.organizationId = state.organizationId = null
    state.isLogged = true
  },

  AUTH_UPDATE_ORGANIZATION_ID(state, { organizationId, organizationUserId, organizationName }) {
    state.organizationId = organizationId
    state.organizationUserId = organizationUserId
    state.organizationName = organizationName
  },

  UPDATE_REGISTER_STEP(state, user) {
    state.newRegister.userId = user.id
    state.newRegister.organizationId = user.organizationId
  },

  // USADO, A PRINCÍPIO, QUANDO SE FIZER LOGOUT
  DEFAULT_AUTH_STATE(state) {
    state.organizationId = null
    state.organizationUserId = null
    state.user = {}
    state.session = {
      user: null,
      organization: null,
      permissions: [],
      features: [],
    }
  },

  DEFAULT_AUTH_STATE_SESSION(state) {
    state.session = {
      user: null,
      organization: null,
      permissions: [],
      features: [],
    }
  },

  SET_SESSION_DATA(state, data) {
    state.session.user = data.user
    state.session.organization = data.organization
    state.session.salesManager = data.salesManager
    state.session.features = data.features
    state.session.permissions = data.permissions
  },

  SET_SESSION_ORGANIZATION_WITHOUT_ACTIVE_PLAN(state) {
    state.session.organization.dontHasPlan = true
  },

  SET_ORGANIZATION_PLAN_STATUS(state, organizationPlanStatus) {
    state.organizationPlanStatus = organizationPlanStatus
  },

  RESET_ORGANIZATION_PLAN_STATUS(state) {
    state.organizationPlanStatus = null
  }
}
